import styled from "styled-components";
import {down, up} from "styled-breakpoints";

export const Wrapper = styled.div`
    padding-top: 70px;

    ${up("md")} {
        padding-top: 100px!important;
    }

    .cart-icons-line{
        margin: 16px 0;
        height: 1px;
        background-color: #F2F2F2;
    }

    ${down("md")} {
        .cart-icons-line{
            margin: 10px 0;
        }
    }
`